import { Route, Routes, Navigate } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/Home";
import Main from "./pages/Main";
import MainLogged from "./pages/MainLogged";
import RequireAuth from "./pages/RequireAuth";
import UserSettings from "./pages/UserSettings";
import FormContainer from "./pages/FormContainer/FormContainer";
import SignInForm from "./components/Forms/Signin";
import SignUpForm from "./components/Forms/Signup";
import SignRecoveryForm from "./components/Forms/SignRecovery";
import SignValidateForm from "./components/Forms/SignValidate";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCategories } from "./redux/slices/category";
import Panaderia from "./components/Categories/Panaderia";
import Seminarios from "./components/Categories/Seminarios";
import Experiencia from "./components/Categories/Experiencia";
import Test from "./components/Test";
import SubCategoryData from "./components/SubCategoryData";
import ProductData from "./components/ProductData";
import CategoryContainer from "./components/CategoryContainer";
import Redes from "./components/Redes";
import BlogList from "./pages/BlogList";
import BlogPage from "./pages/BlogPage";
import { helpHttp } from "./helper/helpHttp";
import { toast } from "react-toastify";
import { ExperienciaExpress } from "./pages/ExperienciaExpress/ExperienciaExpress";
import { CATEGORIES } from "./utils/urlToId";
import { TipsYRecomendaciones } from "./pages/TipsYRecomendaciones/TipsYRecomendaciones";
import { ExperienciaFleischmann } from "./pages/ExperienciaFleischmann/ExperienciaFleischmann";
import { Course } from "./pages/ExperienciaFleischmann/Course/Course";
import { useUser } from "./hooks/useUser";
import styled from "@emotion/styled";
import BackArrow from "./components/BackArrow";
import ExpertosVentasSignIn from "./components/Forms/expertosVentasSignIn/ExpertosVentasSignIn";
import { UpdateUserModal } from "./components/UpdateUserModal/UpdateUserModal";
import { Bizcochuelo } from "./pages/Bizcochuelo/Bizcochuelo";
import { BizcochueloFlat } from "./pages/Bizcochuelo/BizcochueloFlat";
import { Alimentec } from "./pages/Alimentec/Alimentec";
import { Delicake } from "./pages/Delicake/Delicake";

const App = () => {
  const dispatch = useDispatch();
  const { get } = helpHttp();
  const { user } = useUser();

  useEffect(() => {
    const finalCategories = {};
    get("categorias/getCategorias")
      .then((data) => {
        data.datos.forEach((category) => {
          finalCategories[category.nombre] = {
            ...category,
            ...CATEGORIES[category.nombre],
          };
        });

        const categoriesByRolAccess = [];
        Object.entries(finalCategories).filter(([key, value]) => {
          if (value.rolId === user.codigo_rol && value.enable) {
            categoriesByRolAccess.push(value);
          }
        });

        dispatch(setCategories(categoriesByRolAccess));
      })
      .catch((e) => {
        console.log(e);

        toast.error("Ha ocurrido un error");
      });
  }, [user.codigo_rol]);

  return (
    <div className="App">
      <UpdateUserModal />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:BlogId" element={<BlogPage />} />
        <Route
          path="expertosenventasfleishmann"
          element={
            <FormContainer>
              <ExpertosVentasSignIn />
            </FormContainer>
          }
        />
        <Route
          path="sign-in"
          element={
            <FormContainer>
              <SignInForm />
            </FormContainer>
          }
        />
        <Route
          path="sign-up"
          element={
            <FormContainer>
              <SignUpForm />
            </FormContainer>
          }
        />
        <Route
          path="sign-recovery"
          element={
            <FormContainer>
              <SignRecoveryForm />
            </FormContainer>
          }
        />
        <Route
          path="sign-validate"
          element={
            <FormContainer>
              <SignValidateForm />
            </FormContainer>
          }
        />
        <Route element={<RequireAuth />}>
          <Route path="user-settings" element={<UserSettings />} />
          {/* <Route path="bizcochuelo" element={<BizcochueloFlat />} /> */}
          <Route path="alimentec" element={<Alimentec />} />
          <Route path="delicake" element={<Delicake />} />
          <Route path="main" element={<MainLogged />} />
          <Route path="main/*" element={<Main />}>
            <Route
              path="Panader%C3%ADa%20y%20pasteler%C3%ADa"
              element={
                <CategoryContainer>
                  <Panaderia />
                </CategoryContainer>
              }
            />
            <Route
              path="Panader%C3%ADa%20y%20pasteler%C3%ADa/Aprende%20con%20nuestro%20portafolio"
              element={
                <CategoryContainer>
                  <SubCategoryData />
                </CategoryContainer>
              }
            />
            <Route
              path="Panader%C3%ADa%20y%20pasteler%C3%ADa/Nuestras%20recetas"
              element={
                <CategoryContainer>
                  <Redes />
                </CategoryContainer>
              }
            />
            <Route
              path="Panader%C3%ADa%20y%20pasteler%C3%ADa/Tips%20Y%20Recomendaciones"
              element={
                <CategoryContainer>
                  <TipsYRecomendaciones />
                </CategoryContainer>
              }
            />
            <Route
              path="Panader%C3%ADa%20y%20pasteler%C3%ADa/Aprende%20con%20nuestro%20portafolio/:producto"
              element={
                <CategoryContainer>
                  <ProductData />
                </CategoryContainer>
              }
            />
            <Route
              path="Seminarios"
              element={
                <CategoryContainer showPresenciales={false}>
                  <Seminarios />
                </CategoryContainer>
              }
            />
            <Route
              path="Expertos%20Fleischmann"
              element={
                <CategoryContainer>
                  <ExperienciaFleischmann id={"10"} />
                </CategoryContainer>
              }
            />
            <Route
              path="Expertos%20Fleischmann/v2/:category"
              element={
                <CategoryContainer>
                  <ExperienciaFleischmann id={null} />
                </CategoryContainer>
              }
            />
            <Route
              path="Expertos%20Fleischmann/v2/:module/:submodule"
              element={<Course />}
            />
            <Route
              path="Expertos%20Fleischmann/v2/:module/:submodule/:test"
              element={<Test />}
            />
            <Route
              path="Experto%20en%20ventas%20Fleischmann"
              element={
                <CategoryContainer>
                  <ExperienciaFleischmann id={"27"} />
                </CategoryContainer>
              }
            />
            <Route
              path="Experto%20en%20ventas%20Fleischmann/:module"
              element={
                <StyledData>
                  <BackArrow />
                  <ExperienciaFleischmann id={"28"} />
                </StyledData>
              }
            />
            <Route
              path="Experto%20en%20ventas%20Fleischmann/:module/:submodule"
              element={<Course isVentas={true} />}
            />
            <Route
              path="Experto%20en%20ventas%20Fleischmann/:module/:submodule/:test"
              element={<Test isVentas={true} />}
            />
            <Route
              path="Experiencia%20Express"
              element={
                <CategoryContainer>
                  <ExperienciaExpress />
                </CategoryContainer>
              }
            />
            <Route
              path="Expertos%20Fleischmann/:subCategory"
              element={<Course isVentas={false} />}
            />
            <Route
              path="Expertos%20Fleischmann/:subCategory/:test"
              element={<Test />}
            />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={"/"} replace />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
const StyledData = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background-color: #f7f7f7;
  padding: 50px 10px 10px 10px;
  @media (min-width: 768px) {
    padding: 50px 30px;
  }
  //First child is Back arrow
  .arrow {
    position: absolute;
    top: 15px;
    left: 15px;
  }
`;
